import { routePaths } from "./navigation";

export function isRetailCockpitPath(pathname: string) {
    return pathname === routePaths.retailCockpit || pathname.startsWith(`${routePaths.retailCockpit}/`);
}

export function isOnlineCockpitPath(pathname: string) {
    return pathname === routePaths.onlineCockpit || pathname.startsWith(`${routePaths.onlineCockpit}/`);
}

/** Преминаване между Магазини и Онлайн cockpit — без споделени query параметри. */
export function isCrossCockpitModuleNavigation(fromPathname: string, toPathname: string) {
    return (
        (isRetailCockpitPath(fromPathname) && isOnlineCockpitPath(toPathname))
        || (isOnlineCockpitPath(fromPathname) && isRetailCockpitPath(toPathname))
    );
}
